import { defineComponent as _defineComponent } from 'vue'
import IconButton from '../common/base/IconButton.vue';
import ChatIcon from '../common/icons/ChatIcon.vue';
import { useBasicStore } from '../../stores/basic';
import { useChatStore } from '../../stores/chat';
import { storeToRefs } from 'pinia';
import { useI18n } from '../../locales';
import TuiBadge from '../common/base/Badge.vue';
import { roomService } from '../../services';

export default /*#__PURE__*/_defineComponent({
  __name: 'ChatControl',
  setup(__props) {

const { t } = useI18n();
const chatControlConfig = roomService.getComponentConfig('ChatControl');
const basicStore = useBasicStore();
const chatStore = useChatStore();
const { sidebarName } = storeToRefs(basicStore);

async function toggleChatSidebar() {
  if (basicStore.isSidebarOpen && basicStore.sidebarName === 'chat') {
    basicStore.setSidebarOpenStatus(false);
    basicStore.setSidebarName('');
    return;
  }
  basicStore.setSidebarOpenStatus(true);
  basicStore.setSidebarName('chat');
  chatStore.updateUnReadCount(0);
}

return { __sfc: true,t, chatControlConfig, basicStore, chatStore, sidebarName, toggleChatSidebar, IconButton, ChatIcon, TuiBadge }
}

})